export default {"src":"/_next/static/media/sql.40ac560f.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};